﻿import { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { Row, Col, Modal, Button } from "react-bootstrap";
import { useToasts } from "react-toast-notifications";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import _ from "lodash";

import { ReactComponent as PencilSvg } from "@/assets/images/desktop/editar.svg";

import { reorder, toast, validRoles } from "@/services/Utils";

import classes from "../../maintainers.module.scss";
import Fetching from "@/components/Fetching/Fetching";

import { base_element } from "../web.constants";
import { useWebPage } from "@/hooks/maintainers/web";

const WebForm = ({ confirmSave, isLoadingSave, allContents }) => {
	const { addToast } = useToasts();
	const location = useLocation();
	const navigate = useNavigate();
	const { option, selected } = useParams();

	const userRoles = JSON.parse(localStorage.getItem("roles"));
	const isAdmin = validRoles(userRoles, ["administrador"]);

	const [data, setData] = useState({ ...base_element });
	const [contents, setContents] = useState(allContents && allContents.length !== 0 ? allContents : []);

	const { data: response, isLoading } = useWebPage(selected);

	useEffect(() => {
		if (response) {
			setData(response.detail);
		}
	}, [response]);

	const handleClose = () => {
		if (location.state) {
			navigate(location.state);
			return;
		}

		navigate("/mantenedores/paginas_web");
	};

	const validSave = () => {
		if (!data.name) {
			toast(addToast, "Debe ingresar un nombre para guardar.", "error");
			return false;
		}

		return true;
	};

	const handleSave = () => {
		if (validSave()) {
			confirmSave(data);
		}
	};

	const moveContent = (result) => {
		const { source, destination } = result;
		const newContents = contents.filter((c) => !_.map(data.contents, "id").includes(c.id));

		if (!destination) {
			return;
		}
		if (source.index === destination.index && source.droppableId === destination.droppableId) {
			return;
		}

		if (source.droppableId !== destination.droppableId) {
			let sourceItems = [];
			let destinationItems = [];

			if (source.droppableId === "secciones") {
				sourceItems = [...data.contents];
			}
			if (source.droppableId === "secciones_disponibles") {
				sourceItems = [...newContents];
				destinationItems = [...data.contents];
			}

			const [removed] = sourceItems.splice(source.index, 1);
			destinationItems.splice(destination.index, 0, removed);

			if (source.droppableId === "secciones") {
				setData({ ...data, contents: sourceItems });
				setContents([...allContents]);
			}
			if (source.droppableId === "secciones_disponibles") {
				setData({ ...data, contents: destinationItems });
				setContents(sourceItems);
			}

			return;
		}

		if (source.droppableId === "secciones") {
			setData({
				...data,
				contents: reorder(data.contents, source.index, destination.index),
			});
		}

		if (source.droppableId === "secciones_disponibles") {
			setContents(reorder(contents, source.index, destination.index));
		}
	};

	return (
		<Modal show={option ? true : false} onHide={handleClose} backdrop="static" keyboard={false} className={classes.main_form} size={"lg"}>
			<Modal.Header closeButton>
				<h4 className={classes.modal_title}>Página {data ? data.name : ""}</h4>
			</Modal.Header>

			<Modal.Body style={{ paddingTop: "0px", paddingBottom: "0px" }}>
				{isLoading || isLoadingSave ? (
					<Fetching topMargin={"1em"} />
				) : (
					<DragDropContext onDragEnd={(result) => moveContent(result)}>
						<Row className={classes.row_form}>
							<Col md={6} xs={6} className={classes.list}>
								<div className={classes.section_title}>Secciones</div>
								<Droppable droppableId="secciones">
									{(droppableProvided) => (
										<ul {...droppableProvided.droppableProps} ref={droppableProvided.innerRef} className={classes.section_container}>
											{data &&
												data.contents &&
												data.contents.map((content, i) => {
													return (
														<Draggable key={content.id} index={i} draggableId={String(content.id)}>
															{(draggableProvided) => (
																<li
																	{...draggableProvided.draggableProps}
																	ref={draggableProvided.innerRef}
																	{...draggableProvided.dragHandleProps}
																	className={classes.section_item}
																>
																	<div className={classes.section_item_div}>
																		<div>{content.name}</div>
																		<div>
																			<PencilSvg
																				style={{
																					cursor: "pointer",
																				}}
																				onClick={() => navigate("/mantenedores/contenidos_web/editar/" + content.id)}
																			/>
																		</div>
																	</div>
																</li>
															)}
														</Draggable>
													);
												})}
											{droppableProvided.placeholder}
										</ul>
									)}
								</Droppable>
							</Col>
							<Col md={6} xs={6} className={classes.list}>
								<div className={classes.section_title}>Secciones Disponibles</div>
								<Droppable droppableId="secciones_disponibles">
									{(droppableProvided) => (
										<ul {...droppableProvided.droppableProps} ref={droppableProvided.innerRef} className={classes.section_container}>
											{contents &&
												data &&
												contents
													.filter((c) => !_.map(data.contents, "id").includes(c.id))
													.map((content, i) => {
														return (
															<Draggable key={content.id} index={i} draggableId={String(content.id)}>
																{(draggableProvided) => (
																	<li
																		{...draggableProvided.draggableProps}
																		ref={draggableProvided.innerRef}
																		{...draggableProvided.dragHandleProps}
																		className={classes.section_item}
																	>
																		<div className={classes.section_item_div}>
																			<div>{content.name}</div>
																			<div>
																				<PencilSvg
																					style={{
																						cursor: "pointer",
																					}}
																					onClick={() =>
																						navigate("/mantenedores/contenidos_web/editar/" + content.id)
																					}
																				/>
																			</div>
																		</div>
																	</li>
																)}
															</Draggable>
														);
													})}
											{droppableProvided.placeholder}
										</ul>
									)}
								</Droppable>
							</Col>
						</Row>
					</DragDropContext>
				)}
			</Modal.Body>
			<Modal.Footer>
				{isAdmin && !isLoading && (
					<Button variant="success" onClick={handleSave} disabled={isLoading || (isLoadingSave && true)}>
						GUARDAR
					</Button>
				)}
			</Modal.Footer>
		</Modal>
	);
};

export default WebForm;
